<template v-if="!isShow.loading">
  <div v-show="isShow.display">
    <!-- ―――― #index ―――― -->
    <template v-if="isShow.render">
      <DailySchedule :is-mobile="isMobile"></DailySchedule>
    </template>
    <!-- ―――― /#index ―――― -->

    <!-- ―――― #yet ―――― -->
    <template v-if="isShow.render">
      <UnsetSchedule :is-mobile="isMobile"></UnsetSchedule>
    </template>
    <!-- ―――― /#yet ―――― -->

    <!-- ―――― Modal ―――― -->
    <ScheduleUserEditModal></ScheduleUserEditModal>
    <RentalContractModal></RentalContractModal>
    <!-- ―――― ./Modal ―――― -->
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, watchPostEffect } from "vue";
/* DatabaseList */
import { automaticPageReload } from "../../compositions/script/pageReload";
import { getSchedules } from "../../compositions/axios/schedule/scheduleAxios";
import { getDrivingLicenseTypes } from "../../compositions/axios/drivingLicenseType/drivingLicenseTypeAxios";
import { setSearchParams } from "../../compositions/script/searchParam";
import { getGroupingDepartmentUserByMulti } from "../../compositions/axios/user/GroupingDepartmentUserByMultiPulldownAxios";
/* const */
import {
  schedules,
  isShow,
  searchParams,
  driverLicenseTypesForPulldownByVue,
} from "../../compositions/variables";
/* scripts */
import { toggleLoading } from "../../compositions/script/loading";
/* components */
import DailySchedule from "./table/daily.vue"; // スケジュール一覧
import UnsetSchedule from "./table/unset.vue"; // 未設定案件
import ScheduleUserEditModal from "../../components/modal/scheduleUserEditModal.vue";
import RentalContractModal from "../../components/modal/rentalContractModal.vue";
export default defineComponent({
  components: {
    DailySchedule,
    UnsetSchedule,
    ScheduleUserEditModal,
    RentalContractModal,
  },
  props: {
    request: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    ismobile: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  setup(props: { request: any; ismobile: Boolean }) {
    const isMobile = props.ismobile;
    // クエリパラメータ 取得
    setSearchParams(props.request);
    // 担当者変更ダイアログ用ユーザ情報 取得
    getGroupingDepartmentUserByMulti();
    // 運転免許種別情報 取得
    getDrivingLicenseTypes();
    // スケジュール情報 取得
    getSchedules();

    onMounted(() => {
      isShow.loading = false;
      automaticPageReload();
    });
    /**
     * Define LifeCycle Script
     */
    watchPostEffect(() => {
      console.log(isShow.loading);
      toggleLoading();
    });

    return {
      /* variavles */
      schedules,
      isShow,
      searchParams,
      isMobile,
      driverLicenseTypesForPulldownByVue,
    };
  },
});
</script>

<style>
</style>
